import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import Link from "./linkMenu";
import Image from "./image";
import backArrow from "../assets/backDark.png"

const MenuDiv = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgb(222, 222, 222);
  width: 100vw;
  height: 50px;
  position: fixed;
  top: 50px;
  left: 0;
  box-sizing: border-box;
`

const List = styled.ul`
  list-style-type: none;
  height: 50px;
  max-width: 1280px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const MarginImg = styled.div`
  margin-left: 15px;
`

const getLicenceId = () => {
    const login = JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).login)
    return login.licenceSolo
}

const Menu = () => {
    const local = JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).login)
    const [licenceId, setLicenceId] = useState('none')

    useEffect(() => {
        setLicenceId(getLicenceId())
    }, [])

    return (
        <MenuDiv>
            <List>
                {window.location.pathname.split("/")[1] !== "club" ?
                    <li>
                        <MarginImg>
                            <Image src={backArrow} width="25" cursor="pointer" onClick={() => window.history.back()}/>
                        </MarginImg>

                    </li>
                    : null}
                {
                    local && local.admin === "true" ?
                        <>
                            <li><Link content="Création de licence" link={`/create-licence`}/></li>
                            <li><Link content="Ma licence" link={`/licence/${licenceId}`}/></li>
                        </>
                        : null
                }
                {
                    local && local.idClub !== 'none' ?
                        <li><Link content="Mon club" link={`/club/${localStorage.getItem('idClub')}`}/></li>
                        : null
                }
            </List>
        </MenuDiv>
    )
}

export default Menu
